var map = {
	"./1_x1.png": 92977,
	"./1_x2.png": 84666,
	"./1_x4.png": 76076,
	"./1_x7.png": 44551,
	"./2_x2.png": 79635,
	"./2_x4.png": 97189,
	"./2_x6.png": 68407,
	"./2_x8.png": 10329,
	"./3_x12.png": 8741,
	"./3_x3.png": 16261,
	"./3_x6.png": 42488,
	"./3_x9.png": 89820,
	"./4_x12.png": 25582,
	"./4_x16.png": 12714,
	"./4_x4.png": 90147,
	"./4_x8.png": 83135,
	"./normal_multiplier_1.png": 96715,
	"./normal_multiplier_2.png": 9072,
	"./normal_multiplier_4.png": 82278,
	"./normal_multiplier_7.png": 63485,
	"./symbol_0.png": 20401,
	"./symbol_1.png": 80456,
	"./symbol_10.png": 57434,
	"./symbol_11.png": 47267,
	"./symbol_12.png": 68936,
	"./symbol_13.png": 17329,
	"./symbol_14.png": 72766,
	"./symbol_15.png": 48551,
	"./symbol_16.png": 97868,
	"./symbol_17.png": 9493,
	"./symbol_2.png": 33667,
	"./symbol_3.png": 12090,
	"./symbol_4.png": 70037,
	"./symbol_5.png": 3500,
	"./symbol_6.png": 71975,
	"./symbol_7.png": 84286,
	"./symbol_8.png": 83177,
	"./symbol_9.png": 28352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21479;